@import '../../../globals/main.scss';

pn-profile-selector {
  margin: 1em auto;
  display: flex;
  flex-direction: column;
  min-width: 42.4rem;
  max-width: 38.4rem;
  width: 100%;
  padding: 1.6rem;
  border-radius: 8px;
  background: $white;
}

.profileselector-container {
  padding: 3.2rem;
  border-radius: 8px;
  box-shadow:
    0 0.06rem 0.18rem rgba(0, 0, 0, 0.1),
    0 0.32rem 0.72rem rgba(0, 0, 0, 0.13);
  border: 0.1rem solid $gray50;
  display: flex;
  flex-direction: column;
}

.profileselector-logo {
  svg {
    display: block;
    margin: 0 auto 2.4rem;
  }
}

.profileselector-intromessage {
  text-align: center;
  font-weight: 700;
}
